import { SupplierJobEdit } from '@client/components/suppliers/SupplierJobEdit';
import { claimFormStore } from '@client/routes/~console.$orgId/~claims/~details.$id/store';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/claims/details/$id/manage/supplier-jobs/edit/$jobId')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Edit job',
        },
    },
    params: {
        parse({ jobId }) {
            return { jobId: BigInt(jobId) };
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    const { id, jobId } = Route.useParams();
    const isReadonly = claimFormStore.use.isReadonly();

    // CUR-725: a closed claim's job stays VIEWABLE — the drawer renders read-only
    // (fields disabled, no Save) instead of bouncing straight back.
    return <SupplierJobEdit action={['edit', { jobId }]} claimId={id} readOnly={isReadonly} />;
}
